module.exports = __webpack_public_path__ + "img/yinhedesk2.e8db446e.png";